module.exports = __webpack_public_path__ + "img/182.dining_room_cleanlines.63f6635d.svg";